export const ALL_REASON_CODES: { [s: string]: string[] } = {
  EYEWEAR: [
    'Cracks or Scatches (If unworn) - Lens​',
    'Peeling coating - Lens​',
    'Colour Difference between the right and the left  - Lens​',
    'Lens Detached - Lens​',
    'Alignment is not OK - Frame​',
    'Cracks around screws - Frame',
    'Screws become loose - Frame',
    'Spring hinge function fails - Frame​',
    'Broken nosepad - Frame​',
    'Broken or loose hinges - Frame​',
    'Scratches (If unworn) - Frame​',
    'Oxidation or discoloration (If unworn) - Frame​',
    'Non-warranty',
  ],
  WATCH: [
    'Condensation',
    'Crown Damage',
    'Dust on Dial',
    'Glass Scratched',
    'Hands Damaged/Detached',
    'Index Detached',
    'Movement Fast',
    'Movement Slow',
    'Movement Stopped',
    'Non-warranty',
    'Oxidation',
    'Scratch on Watch Head',
    'Separation of three-piece links',
    'Stain/Oxidation on Hands',
    'Unsynchronized Hands',
    'Leakage',
    'Loose screws',
  ],
  STRAP: [
    'Non-warranty',
    'Seperation of the Fixed Links, LW',
    'Dirt on',
    'Faulty Clasp',
    'Oxidation',
    'Scratch on Leather',
    'Scratch on Buckles',
    'Scratch on Mesh',
    'Spring in Clasp is Broken, LW',
  ],
  'SMART ACC': [
    'Button not working',
    'Crown not working ',
    'Scratched case (Manufacturing defect)',
    'Non-warranty',
  ],
  'GIFT BOXES': ['Non-warranty', 'Packaging Box is Damaged'],
  ACCESSORY: ['Non-warranty', 'Epoxy came off', 'Oxidation', 'Scratch','Loose stones'],
}

export const getSpecifiedReasonCodes: (s: string) => string[] = (reasonCode: string) =>
  ALL_REASON_CODES[reasonCode] || []
export const REASON_CODES = Object.keys(ALL_REASON_CODES)
